export { default as Box } from './Box'
export { default as BoxHeader } from './BoxHeader'
export { default as BoxContent } from './BoxContent'
export { default as BoxSimpleHeader } from './BoxSimpleHeader'



// WEBPACK FOOTER //
// ./src/shared/components/Box/index.js